import { useEffect, useState } from "react";
import { settings as settingsApi } from "../../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminSettings() {
  const [form, setForm] = useState(null);
  useEffect(() => { settingsApi.get().then(setForm); }, []);
  if (!form) return null;

  const save = async () => {
    try { await settingsApi.update(form); toast.success("Settings updated"); }
    catch (e) { toast.error("Save failed"); }
  };

  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <div data-testid="admin-settings">
      <div className="flex justify-between items-center mb-8">
        <div><span className="eyebrow">— Settings</span><h1 className="font-display text-4xl mt-2">Site <span className="italic text-gold">Settings</span></h1></div>
        <button onClick={save} className="btn-luxe btn-luxe-solid" data-testid="save-settings"><Save size={14} /> Save</button>
      </div>
      <div className="glass p-8 space-y-5 max-w-3xl">
        <Field label="Hero Headline"><input className="luxe-input" value={form.hero_headline} onChange={update("hero_headline")} /></Field>
        <Field label="Hero Subheadline"><textarea rows={2} className="luxe-input" value={form.hero_subheadline} onChange={update("hero_subheadline")} /></Field>
        <Field label="Hero Video URL (mp4)"><input className="luxe-input" placeholder="https://…/hero.mp4" value={form.hero_video_url} onChange={update("hero_video_url")} /></Field>
        <Field label="Hero Poster Image URL"><input className="luxe-input" value={form.hero_poster_url} onChange={update("hero_poster_url")} /></Field>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <Field label="Address"><input className="luxe-input" value={form.address} onChange={update("address")} /></Field>
          <Field label="Phone"><input className="luxe-input" value={form.phone} onChange={update("phone")} /></Field>
          <Field label="Contact Email"><input className="luxe-input" value={form.contact_email} onChange={update("contact_email")} /></Field>
          <Field label="Instagram URL"><input className="luxe-input" value={form.instagram_url} onChange={update("instagram_url")} /></Field>
          <Field label="Default Min Spend ($)"><input type="number" className="luxe-input" value={form.default_min_spend} onChange={e => setForm({ ...form, default_min_spend: parseFloat(e.target.value) })} /></Field>
          <Field label="Default GA Price ($)"><input type="number" className="luxe-input" value={form.ga_default_price} onChange={e => setForm({ ...form, ga_default_price: parseFloat(e.target.value) })} /></Field>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }) { return <div><label className="eyebrow block mb-2">{label}</label>{children}</div>; }
